import { request } from '../client';
import { endpoints } from '../endpoints';
import { asList } from './shape';

/**
 * Target group templates: reusable basics, region, profiling and quotas.
 * clientId null = company-wide; otherwise only for that client. Ids inside a template are copied as-is.
 */

/** With a clientId: the company-wide templates plus that client's own. Without: every template. */
export const listTemplates = async (clientId, opts) =>
  asList(await request(endpoints.templates.all(), { query: clientId ? { clientId } : undefined, ...opts }));

/** Save a target group's current settings as a template. clientId: a client id, or null for company-wide. */
export const createTemplateFromTargetGroup = async (tgId, { name, description, clientId }) => {
  const template = await request(endpoints.templates.fromTargetGroup(tgId), { method: 'POST', body: { name, description, clientId } });
  if (template === null || template === undefined) throw new Error('The template was not saved: the server did not find the target group.');
  return template;
};

export const deleteTemplate = (id) => request(endpoints.templates.byId(id), { method: 'DELETE' });

/**
 * Copy a template into a target group: its basics, region and quotas (each updates the existing record in place) and
 * its profiling selection when it has one; sections the template lacks stay unchanged. Everything is checked first:
 * any problem is a 400 with `errors` and nothing is saved; an unknown template is a 404. Resolves the target group.
 */
export const applyTemplate = async (projectId, tgId, templateId) => {
  const group = await request(endpoints.targetGroups.applyTemplate(projectId, tgId, templateId), { method: 'POST' });
  if (group === null || group === undefined) throw new Error('The template was not applied: the server did not find the campaign or target group.');
  return group;
};
